import { render } from "./guide-page.vue?vue&type=template&id=7e6f8904&scoped=true"
import script from "./guide-page.vue?vue&type=script&lang=js"
export * from "./guide-page.vue?vue&type=script&lang=js"

import "./guide-page.vue?vue&type=style&index=0&id=7e6f8904&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e6f8904"]])

export default __exports__